export const getQueryParams = (params) => {
    return Object.keys(params)
        .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");
};
//# sourceMappingURL=utils.js.map